import { ISlide } from './ISlide';

const showdown = require('showdown');
export class ChapterSlide implements ISlide {
  constructor(private readonly title: string) {}

  public get loaded(): boolean {
    return true;
  }

  public get content(): string {
    return '<h1 class="chapter">' + this.title + '</h1>';
  }
}
